export abstract class BaseModel {
    _id: string;
    country: string;

}
